var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ForumChatThreadCardHeaderMeta"},[_c('ForumChatThreadCardHeaderProfile',{attrs:{"thread":_vm.thread,"dark":_vm.dark}}),_c('ForumChatThreadCardHeaderTimestamp',{staticClass:"ForumChatThreadCardHeaderMeta__timestamp",attrs:{"thread":_vm.thread,"compact":_vm.compact,"mobile":_vm.mobile,"dark":_vm.dark}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }